import React from 'react'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

const SpinLoader = (props) => (
  <Spin
    size="large"
    indicator={<LoadingOutlined />}
    {...props}
  />
)

export default SpinLoader
